import type React from 'react'

type Props = { size?: number; color?: string; className?: string }

const ExternalLinkIcon: React.FC<Props> = ({
  size = 16,
  color = '#1890FF',
  className
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M9.91699 2.25H13.7503V6.08333"
      stroke={color}
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.72266 9.27778L13.7504 2.25"
      stroke={color}
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8333 8.63891V12.4722C11.8333 12.8111 11.6987 13.1361 11.4591 13.3758C11.2195 13.6154 10.8944 13.75 10.5556 13.75H3.52778C3.18889 13.75 2.86388 13.6154 2.62425 13.3758C2.38462 13.1361 2.25 12.8111 2.25 12.4722V5.44446C2.25 5.10558 2.38462 4.78057 2.62425 4.54094C2.86388 4.30131 3.18889 4.16669 3.52778 4.16669H7.36111"
      stroke={color}
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ExternalLinkIcon
